<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header
      (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"
    ></app-header>
    <div class="sggs-dashboard-content">
      <div class="small-carousel carousel-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="title-banner-wrapper {{bannerClass}}" style="background-image: url('assets/images/{{bannerImage}}');">
          <h1 class="bani-title">
            {{ activeLanguageTranslations?.approachLabel }}
          </h1>
        </div>
      </div>
      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">

        <!-- <div class="static-content-heading-wrapper">
          {{ activeLanguageTranslations?.approachLabel }}
        </div> -->

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.sggsProject }}  <br />
          {{ activeLanguageTranslations?.subTagLine }}
        </div>

        <h2 class="static-content-heading-wrapper">
          {{ activeLanguageTranslations?.theVision }}
        </h2>

       <!-- Overview Start -->
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.visionParagraphOne  }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.visionParagraphTwo  }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.visionParagraphThree  }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.visionParagraphFour  }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.visionParagraphFive  }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.visionParagraphSix  }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.visionParagraphSeven  }}
        </div><div class="static-content-paragraph">
          {{ activeLanguageTranslations?.visionParagraphEight  }}
        </div>

        <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.seekingTheLivingGuru  }}</b> <br /><br />
          {{ activeLanguageTranslations?.seekingParagraphOne  }} <br> <br />
          {{ activeLanguageTranslations?.seekingParagraphTwo  }}
        </div>

        <div class="static-content-heading-wrapper">
          {{ activeLanguageTranslations?.focusingGlobalHeading }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.focusingGlobalParagraphOne }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.focusingGlobalParagraphTwo }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.focusingGlobalParagraphThree }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.focusingGlobalParagraphFour }}
        </div>

        <div class="static-content-heading-wrapper">
          {{ activeLanguageTranslations?.roadMapHeading }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.roadMapParagraphOne }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.roadMapParagraphTwo }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.roadMapParagraphThree }}
        </div>

        <div class="static-content-heading-wrapper"> {{ activeLanguageTranslations?.disclaimerHeading }}</div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.disclaimerParagraphOne }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.disclaimerParagraphTwo }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.disclaimerParagraphThree }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.disclaimerParagraphFour }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.disclaimerParagraphFive }}
        </div>

        <div class="static-content-wrapper pl-20">
          <b><a href="https://sikhri.org/" target="_blank" class="view-more-link">{{ activeLanguageTranslations?.biBooksHeading }}</a></b>
        </div>
        <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.textbooksLabel }}</b>
          <a href="{{ activeLanguageTranslations?.textBookLink1}}" target="_blank" class="view-more-link"> {{ activeLanguageTranslations?.textbooksDetail1 }}</a> &nbsp;
          <a href="{{ activeLanguageTranslations?.textBookLink2}}" target="_blank" class="view-more-link"> {{ activeLanguageTranslations?.textbooksDetail2 }}</a>
        </div>
        <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.bitextbooksLabel }}</b> 
          <a href="{{ activeLanguageTranslations?.bitextbooksLink1}}" target="_blank" class="view-more-link"> {{ activeLanguageTranslations?.bitextbooksDetail1 }}</a>&nbsp;
          <a href="{{ activeLanguageTranslations?.bitextbooksLink2}}" target="_blank" class="view-more-link"> {{ activeLanguageTranslations?.bitextbooksDetail2 }}</a>&nbsp;
          <a href="{{ activeLanguageTranslations?.bitextbooksLink3}}" target="_blank" class="view-more-link"> {{ activeLanguageTranslations?.bitextbooksDetail3 }}</a>&nbsp;

        </div>
        <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.chtextbooksLabel }}</b> 
          <a href="{{ activeLanguageTranslations?.chtextbooksLink1}}" target="_blank" class="view-more-link"> {{ activeLanguageTranslations?.chtextbooksDetail1 }}</a>&nbsp;
          <a href="{{ activeLanguageTranslations?.chtextbooksLink2}}" target="_blank" class="view-more-link">{{ activeLanguageTranslations?.chtextbooksDetail2 }}</a>&nbsp;
          <a href="{{ activeLanguageTranslations?.chtextbooksLink3}}" target="_blank" class="view-more-link">{{ activeLanguageTranslations?.chtextbooksDetail3 }}</a>&nbsp;
          <a href="{{ activeLanguageTranslations?.chtextbooksLink4}}" target="_blank" class="view-more-link">{{ activeLanguageTranslations?.chtextbooksDetail4 }}</a>&nbsp;
          <a href="{{ activeLanguageTranslations?.chtextbooksLink5}}" target="_blank" class="view-more-link">{{ activeLanguageTranslations?.chtextbooksDetail5 }}</a>&nbsp;
          <a href="{{ activeLanguageTranslations?.chtextbooksLink6}}" target="_blank" class="view-more-link">{{ activeLanguageTranslations?.chtextbooksDetail6 }}</a>&nbsp;
        </div>

        <div class="static-content-paragraph">
          <b> {{ activeLanguageTranslations?.lessonPlanHeading }} </b> {{ activeLanguageTranslations?.lessonPlanDetail }}
        </div>
        <div class="static-content-paragraph">
          <b> {{ activeLanguageTranslations?.sikhriOnlineHeading }}  </b> 
          <a href="{{ activeLanguageTranslations?.sikhriOnlineLink1}}" target="_blank" class="view-more-link">{{ activeLanguageTranslations?.sikhriOnlineParagraph1 }}</a>&nbsp;
          <a href="{{ activeLanguageTranslations?.sikhriOnlineLink2}}" target="_blank" class="view-more-link">{{ activeLanguageTranslations?.sikhriOnlineParagraph2 }}</a>&nbsp;
          <a href="{{ activeLanguageTranslations?.sikhriOnlineLink3}}" target="_blank" class="view-more-link">{{ activeLanguageTranslations?.sikhriOnlineParagraph3 }}</a>&nbsp;
          <a href="{{ activeLanguageTranslations?.sikhriOnlineLink4}}" target="_blank" class="view-more-link">{{ activeLanguageTranslations?.sikhriOnlineParagraph4 }}</a>&nbsp;
          <a href="{{ activeLanguageTranslations?.sikhriOnlineLink5}}" target="_blank" class="view-more-link">{{ activeLanguageTranslations?.sikhriOnlineParagraph5 }}</a>&nbsp;
          <a href="{{ activeLanguageTranslations?.sikhriOnlineLink6}}" target="_blank" class="view-more-link">{{ activeLanguageTranslations?.sikhriOnlineParagraph6 }}</a>&nbsp;
          <a href="{{ activeLanguageTranslations?.sikhriOnlineLink7}}" target="_blank" class="view-more-link">{{ activeLanguageTranslations?.sikhriOnlineParagraph7 }}</a>&nbsp;
          <a href="{{ activeLanguageTranslations?.sikhriOnlineLink8}}" target="_blank" class="view-more-link">{{ activeLanguageTranslations?.sikhriOnlineParagraph8 }}</a>&nbsp;
          <a href="{{ activeLanguageTranslations?.sikhriOnlineLink9}}" target="_blank" class="view-more-link">{{ activeLanguageTranslations?.sikhriOnlineParagraph9 }}</a>&nbsp;
          <a href="{{ activeLanguageTranslations?.sikhriOnlineLink10}}" target="_blank" class="view-more-link">{{ activeLanguageTranslations?.sikhriOnlineParagraph10 }}</a>&nbsp;
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.sikhriOnlineParagraphTwo }} 
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.sikhriOnlineParagraphThree }} 
        </div>
        <!-- Overview End -->

        
      </div>
      <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
